// src/components/user/controltower/StatusFooter.jsx
import React from 'react';
import { AlertTriangle, CheckCircle, Loader2, TruckIcon } from 'lucide-react';

function StatusFooter({ deliveryPoints, alertSummary }) {
  const encamino = deliveryPoints.filter(d => d.status === 'encamino').length;
  const pending = deliveryPoints.filter(d => d.status === 'pending').length;

  const allDone = deliveryPoints.length > 0 && deliveryPoints.every(
    d => ['entregado', 'cancelado', 'rechazado'].includes(d.status)
  );

  if (allDone && !alertSummary?.total) {
    return (
      <div className="flex-shrink-0 bg-brand-green text-white shadow-lg z-30 px-3 sm:px-4 py-2.5 safe-area-bottom">
        <div className="flex items-center justify-center gap-2">
          <CheckCircle className="w-5 h-5" />
          <p className="text-xs sm:text-sm font-bold font-montserrat text-center">Servicio finalizado - todas las entregas completadas</p>
        </div>
      </div>
    );
  }

  const hasActivity = encamino > 0 || pending > 0 || alertSummary?.total > 0;

  if (!hasActivity) {
    return (
      <div className="flex-shrink-0 bg-slate-200 text-slate-700 shadow-lg z-30 px-3 sm:px-4 py-2.5 safe-area-bottom">
        <div className="flex items-center justify-center gap-2">
          <p className="text-xs sm:text-sm font-bold font-montserrat">Sin entregas activas</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-shrink-0 bg-white border-t border-slate-200 shadow-lg z-30 px-3 sm:px-4 py-2 safe-area-bottom">
      <div className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap">
        {(encamino > 0 || pending > 0) && (
          <div className="flex items-center gap-1.5">
            <TruckIcon className="w-4 h-4 text-brand-primary" />
            <span className="text-xs font-semibold text-slate-700 font-montserrat">Lima:</span>
            {encamino > 0 && (
              <span className="text-xs bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded-full font-montserrat font-semibold">
                {encamino} en camino
              </span>
            )}
            {pending > 0 && (
              <span className="text-xs bg-orange-100 text-orange-700 px-1.5 py-0.5 rounded-full font-montserrat font-semibold">
                {pending} pendiente{pending !== 1 ? 's' : ''}
              </span>
            )}
          </div>
        )}

        {alertSummary?.total > 0 && (
          <div className={`flex items-center gap-1.5 rounded-full px-2 py-0.5 ${alertSummary.high > 0 ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>
            <AlertTriangle className={`w-4 h-4 ${alertSummary.high > 0 ? 'animate-pulse' : ''}`} />
            <span className="text-xs font-extrabold font-montserrat">
              {alertSummary.total} alerta{alertSummary.total !== 1 ? 's' : ''}
              {alertSummary.high > 0 ? ` - ${alertSummary.high} critica${alertSummary.high !== 1 ? 's' : ''}` : ''}
            </span>
          </div>
        )}

        <Loader2 className="w-4 h-4 text-slate-400 animate-spin" />
      </div>
    </div>
  );
}

export default StatusFooter;
